import { createAction } from 'redux-actions';
import {
  PapiDaBrowseFaceted,
  PapiRequestDaBrowseFaceted,
} from '@wix/da-types-papi';
import { Pages } from '../../constants';
import {
  AnyPapiDaBrowseNetworkbarRequest,
  AnyPapiDaBrowseNetworkbarResponse,
} from '../../types/api';
import { createCallbackActionCreator } from '@wix/da-shared-react/pkg/Stream/helpers';

export const initFacetData = createAction(
  'BROWSE.FACET.INIT_FACET_DATA',
  (
    page: Pages,
    initData: Omit<PapiDaBrowseFaceted, 'session'>,
    requestParams: PapiRequestDaBrowseFaceted
  ) => ({ page, initData, requestParams })
);

export const initPageData = createAction(
  'BROWSE.INIT_PAGE_DATA',
  (data: {
    pageType: string;
    feedType: string;
    initData: AnyPapiDaBrowseNetworkbarResponse;
    requestParams: AnyPapiDaBrowseNetworkbarRequest;
    requestEndpoint: string;
  }) => data
);

export const offsetChanged = createAction(
  'BROWSE.FACET.OFFSET_CHANGED',
  (offset: number) => ({ offset })
);

export const fetchFacetStreamNext = createAction(
  'BROWSE.FACET.STREAM_NEXT',
  (streamId: string) => ({ streamId })
);

export const fetchPageStreamNext = createCallbackActionCreator(
  'BROWSE.STREAM_NEXT'
);
